module.exports = __webpack_public_path__ + "static/CircularPro-Black.39e1b6ce.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-Black.woff
// module id = 713
// module chunks = 168707334958949